import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { User } from 'src/app/shared/model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { IndustriepartnerService } from 'src/app/core/services/interfaces/industriepartner.service';

@Component({
    selector: 'app-logged-in',
    templateUrl: './logged-in.component.html',
    styleUrls: ['./logged-in.component.scss'],
})
export class LoggedInComponent implements OnInit, OnDestroy {
    user: User;
    userSub: Subscription;

    constructor(
        private auth: AuthService,
        private router: Router,
        private industriepartnerService: IndustriepartnerService
    ) {}

    ngOnInit() {
        this.userSub = this.auth.currentUser.subscribe(user => {
            this.user = user;
        });
    }

    ngOnDestroy(): void {
        if (this.userSub) {
            this.userSub.unsubscribe();
        }
    }

    logout() {
        this.industriepartnerService.setAnbieterNr(null);
        this.auth.logout();
        this.router.navigate(['login']);
    }
}
